export function get(key, defaultValue) {
  const item = localStorage.getItem(key);
  if (item == null) return defaultValue;
  try {
    return JSON.parse(item);
  } catch (err) {
    console.warn(`persist key ${key} error: ${err.message}`);
    return defaultValue;
  }
}

export function set(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function remove(key) {
  localStorage.removeItem(key);
}

window.clearState = clearState;

function clearState() {
  localStorage.clear();
}

// const EXPECTED_VERSION = "008";
// let lastVersion = get("cached-app-version");
// console.log("Last version", lastVersion);
// if (lastVersion && lastVersion !== EXPECTED_VERSION) {
//   console.log("Saw an older verison, clearing app state");
//   clearState();
// }
// set("cached-app-version", EXPECTED_VERSION);
